import PauseIcon from '@mui/icons-material/Pause';
import { Button } from '@mui/material';

export default function PauseButton({ onPause, primaryColor, secondaryColor }) {
  return (
    <Button
      variant="contained"
      size="small"
      startIcon={<PauseIcon fontSize="small" />}
      onClick={onPause}
      sx={{
        padding: '4px 12px',
        fontSize: '0.75rem',
        minWidth: '100px',
        borderRadius: '6px',
        backgroundColor: primaryColor, // Mantiene el color de fondo primario
        color: secondaryColor, // Color del texto secundario
        '&:hover': {
          backgroundColor: secondaryColor,
          opacity: 0.9,
          color: primaryColor, // Mantiene el color del texto en hover
        },
      }}
    >
      Guardar Borrador
    </Button>
  );
}